import todoTypes from "../../constants/todoTypes";
import { getCollectionData, getDocumentData } from "../../helpers/index";
import runTransaction from "../../utils/runTransaction";

import createTodoResolvedData from "../todos/data/todos/createTodoResolvedData";
import { Todo } from "../todos/types/Todo";
import createTodoRef from "../todos/utils/createTodoRef";

import sessionStatuses from "./constants/sessionStatuses";

export default async function cancelSession(firebase, { session, cancelReason, user }) {
	const db = firebase.firestore();

	const productionSessions = await getCollectionData(
		db.collection("sessions").where("production", "==", session.production),
	);

	const sortedOtherSessions = productionSessions
		.filter(({ id, status }) => id !== session?.id && status !== sessionStatuses.CANCELLED)
		.sort((a, b) => a.start - b.start);

	return runTransaction(firebase, [session.ref], async (transaction, [session]) => {
		if (session.productionPriceRef) {
			transaction.delete(session.productionPriceRef);
		}

		transaction.update(session.ref, {
			status: sessionStatuses.CANCELLED,
			first: false,
			cancelReason,
		});

		const sessionMissingRecorderTodoRef = createTodoRef(db, session.id, todoTypes.SESSION_MISSING_RECORDER);

		const sessionMissingRecorder = await getDocumentData(sessionMissingRecorderTodoRef);

		if (sessionMissingRecorder) {
			transaction.update(
				sessionMissingRecorderTodoRef,
				Todo.partial().parse({
					resolved: createTodoResolvedData(firebase, { user }),
				}),
			);
		}

		sortedOtherSessions.forEach((session, index) => {
			transaction.update(session.ref, { first: index === 0 });
		});
	});
}
